import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useArticlesByTags } from "@administration/hooks/ArticlesHook";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ImageContainer from "@shared/components/contents/imageContainer/ImageContainer";
import { useSites } from "@shared/hooks/SiteHook";
import { removeDuplicatesObjects } from "@shared/utils/ArrayUtils";
import { useEffect, useState } from "react";
import ProjectArticleSubpage from "./ProjectArticleSubpage";
const ProjectArticleTemplate = ({ page }) => {
    const [relatedArticles, setRelatedArticles] = useState([]);
    const { currentSite } = useSites();
    const { image, contents = {}, tags, page: pageInfo, pageId } = page || {};
    const { parentId = "" } = pageInfo || {};
    const { contactBlock, dynamicPart } = Array.isArray(contents)
        ? contents.at(0) || {}
        : contents;
    const { data = [], pending } = useArticlesByTags(parentId, currentSite?.id, tags);
    //Sert a récupérer les articles qui sont en rapport avec l'actuel (même tags)
    useEffect(() => {
        if (pending) {
            return;
        }
        const articles = data
            .map((result) => result?.data)
            .flatMap((result) => result?.data ?? []);
        const uniqueArticles = removeDuplicatesObjects(articles, (article) => article.id);
        setRelatedArticles(uniqueArticles.filter((article) => article.pageId !== pageId));
    }, [data, pageId, pending]);
    return (_jsx(Container, { sx: {
            maxWidth: "1208px !important",
            py: { xs: "40px", md: "64px" },
            position: "relative",
        }, children: _jsxs(Stack, { spacing: { xs: 5, md: 7 }, children: [_jsxs(Grid, { container: true, spacing: { xs: 5, md: 8 }, children: [_jsx(Grid, { size: { xs: 12, md: 8 }, children: _jsx(Stack, { spacing: 3, sx: {
                                    mt: { xs: "204px", md: 0 },
                                }, children: _jsx(Box, { children: dynamicPart }) }) }), _jsx(Grid, { size: { xs: 12, md: 4 }, children: _jsxs(Stack, { spacing: 3, sx: {
                                    mt: { xs: 0, md: "200px" },
                                }, children: [image && (_jsx(Box, { sx: {
                                            position: "absolute",
                                            zIndex: 100,
                                            maxWidth: "400px",
                                            width: { xs: "calc(100% - 24px)", md: "calc(100% + 64px)" },
                                            maxHeight: "300px",
                                            height: "100%",
                                            border: "solid 10px white",
                                            top: { xs: -100, md: -250 },
                                            right: { xs: 12, md: 0 },
                                        }, children: _jsx(ImageContainer, { ratio: "", children: _jsx(_Fragment, { children: image }) }) })), _jsxs(Stack, { spacing: 3, sx: {
                                            backgroundColor: "background.default",
                                            p: 4,
                                            border: "solid 1px",
                                            borderColor: "border.grey",
                                            width: "100%",
                                            mt: 6,
                                        }, children: [_jsx(Typography, { component: "h2", variant: "subtitle1", sx: {
                                                    fontSize: "18px",
                                                    lineHeight: "133%",
                                                    letterSpacing: "2%",
                                                }, children: "\u00C0 d\u00E9couvrir \u00E9galement" }), !pending && relatedArticles.length > 0 ? (relatedArticles.map((article) => (_jsx(ProjectArticleSubpage, { page: article }, article.id)))) : !pending ? (_jsx(Typography, { component: "p", variant: "subtitle2", children: "Aucun article trouve" })) : (_jsx(Typography, { component: "p", variant: "subtitle2", children: "Chargement en cours..." }))] })] }) })] }), contactBlock] }) }));
};
export default ProjectArticleTemplate;
